import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

const MarkerWrapper = ({ value, content, top }) => {
  const [up, setUp] = useState(false);
  const [size, setSize] = useState({});
  const ref = useRef(null);
  useLayoutEffect(() => {
    if (ref.current) {
      setSize({ width: ref.current.scrollWidth, height: ref.current.scrollHeight });
    }
  }, [value]);

  const onEnter = useCallback(() => setUp(true), []);
  const onLeave = useCallback(() => setUp(false), []);

  return (
    <S.Marker
      ref={ref}
      $up={up}
      $width={size.width}
      $height={size.height}
      $top={top}
      $left={value}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}>
      {content}
    </S.Marker>
  );
};

export const RangeGradient = ({ marks, colors, height, sharpGradient }) => {
  return (
    <S.Gradient $trailColors={colors} $height={height} $sharpGradient={sharpGradient}>
      {marks.map((m, i) => (
        /** Using index to allow transition to work when value is changed.
         * amount of marks should not change */
        <MarkerWrapper key={i} value={m.value} content={m.content} top={m.top} />
      ))}
    </S.Gradient>
  );
};

RangeGradient.propTypes = {
  marks: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node,
      top: PropTypes.string,
      value: PropTypes.number
    })
  ),
  colors: PropTypes.arrayOf(PropTypes.string),
  height: PropTypes.number,
  sharpGradient: PropTypes.bool
};
